import { noop } from 'lodash'

export default {
    inject: ['Entity'],
    data () {
        return {
            entity: (this.$options.entity || noop).call(this),
        }
    },
    beforeMount () {
        this.Entity.store = { ...(this.entity || {}) }
    },
    destroyed () {
        this.resetEntity()
    },
    methods: {
        resetEntity (options) {
            this.Entity.store = {}
        },
        setEntity (options) {
            this.Entity.store = { ...(this.entity || {}), ...(options || {}) }
        },
    },
}
